<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="保险公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag type="list" v-decorator="['company', validatorRules.company]" :trigger-change="true"
                                   dict="biz_insurance_company,name,code" placeholder="请输入保险公司">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="九安数据列名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['jiuanColumn', validatorRules.jiuanColumn]" :trigger-change="true" dictCode="bms_insurance_data_column" placeholder="请选择九安数据列名"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保司表格列名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insuranceColumn', validatorRules.insuranceColumn]" placeholder="请输入保司表格列名"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"

  export default {
    name: 'BizInsuranceExcelCompareForm',
    components: {
      JFormContainer,
      JDictSelectTag,
      JSearchSelectTag
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          company: {
            rules: [
              { required: true, message: '请选择公司' },
            ]
          },
          jiuanColumn: {
            rules: [
              { required: true, message: '请选择九安数据列名' }
            ]
          },
          insuranceColumn: {
            rules: [
              { required: true, message: '请输入保司表格列名' },
              { max: 20, message: '保司表格列名不能超过20个字符'}
            ]
          }
        },
        url: {
          add: "/bms/bizInsuranceExcelCompare/add",
          edit: "/bms/bizInsuranceExcelCompare/edit",
          queryById: "/bms/bizInsuranceExcelCompare/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'company','jiuanColumn','insuranceColumn'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'company','jiuanColumn','insuranceColumn'))
      },
    }
  }
</script>